import { ComponentsOverrides, Theme } from "@mui/material";
import { CSSObject } from "@mui/system";

import borders from "@/themes/base/borders";
import colors from "@/themes/base/colors";
import pxToRem from "@/themes/functions/pxToRem";

const { borderRadius } = borders;
const { light } = colors;

interface ILinearProgress {
  styleOverrides: ComponentsOverrides<Theme>["MuiLinearProgress"];
}

const linearProgress: ILinearProgress = {
  styleOverrides: {
    root: {
      height: pxToRem(6),
      borderRadius: borderRadius.md,
      overflow: "visible",
      position: "relative",
    } as CSSObject,

    colorPrimary: {
      backgroundColor: light.main,
    } as CSSObject,

    colorSecondary: {
      backgroundColor: light.main,
    } as CSSObject,

    bar: {
      height: pxToRem(6),
      borderRadius: borderRadius.sm,
      position: "absolute",
      transform: "translate(0, 0) !important",
      transition: "width 0.6s ease !important",
    } as CSSObject,
  },
};

export default linearProgress;
